export const ALLOWED_RIDER_TEAM_CODE = "EA9997";
export const RIDER_TEAM_ACCESS_DENIED_MESSAGE = "目前此團隊不開放乘客預約";

type TeamLike = {
  code?: string | null;
};

type UserLike = {
  teamCode?: string | null;
  team?: TeamLike | null;
};

export const getUserTeamCode = (user: UserLike | null | undefined) => {
  return user?.team?.code ?? user?.teamCode ?? "";
};

export const isAllowedRiderTeamUser = (user: UserLike | null | undefined) => {
  return getUserTeamCode(user) === ALLOWED_RIDER_TEAM_CODE;
};
